import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import * as styles from "./TakeATour.module.scss";

function TakeATour({ DesktopSvg, MobileSvg }) {
  const dispatch = useDispatch();
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    // Hide the floating button whenever the in-page contact form (#contact)
    // is intersecting the viewport, so the button doesn't overlap the form.
    let observer;
    let target = null;

    const attachObserver = () => {
      target = document.getElementById("contact");
      if (!target || typeof IntersectionObserver === "undefined") return false;
      observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          setHidden(entry.isIntersecting);
        },
        { rootMargin: "0px 0px -10% 0px", threshold: 0 }
      );
      observer.observe(target);
      return true;
    };

    // Contact form may not yet be mounted on first render; retry briefly.
    if (!attachObserver()) {
      const retry = setInterval(() => {
        if (attachObserver()) clearInterval(retry);
      }, 250);
      const stopRetry = setTimeout(() => clearInterval(retry), 5000);
      return () => {
        clearInterval(retry);
        clearTimeout(stopRetry);
        if (observer && target) observer.unobserve(target);
      };
    }

    return () => {
      if (observer && target) observer.unobserve(target);
    };
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    // TODO: When Gomes confirms RentCafe direct link, swap this for
    // window.open(rentCafeUrl, "_blank"). Until then, scroll to the in-page
    // contact form preset on the TOUR option.
    dispatch({ type: "SET_CONTACT_TOUR" });
    const target = document.getElementById("contact");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, "", "#contact");
      }
    } else {
      window.location.hash = "#contact";
    }
  };

  return (
    <div
      className={classNames(styles.container, { [styles.hidden]: hidden })}
      aria-hidden={hidden ? "true" : "false"}
    >
      <a
        href="#"
        onClick={handleClick}
        aria-label="Take a Tour"
        className={styles.link}
      >
        <DesktopSvg className={styles.desktop} aria-hidden="true" />
        <MobileSvg className={styles.mobile} aria-hidden="true" />
      </a>
    </div>
  );
}

TakeATour.propTypes = {
  DesktopSvg: PropTypes.elementType.isRequired,
  MobileSvg: PropTypes.elementType.isRequired,
};

export default TakeATour;
